module.exports = __webpack_public_path__ + "img/b1057f7b-3e0e-9687-aa55-56cfed42147a0.19589437.webp";